import { render, staticRenderFns } from "./ScrollNavigation.vue?vue&type=template&id=6812d3d5"
import script from "./ScrollNavigation.vue?vue&type=script&lang=js"
export * from "./ScrollNavigation.vue?vue&type=script&lang=js"
import style0 from "./ScrollNavigation.vue?vue&type=style&index=0&id=6812d3d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports